// extracted by mini-css-extract-plugin
export default {"container":"Package_container__+E9hr","body":"Package_body__15r37","textValue":"Package_textValue__du0ah","buttonAction":"Package_buttonAction__iTMtO"};